import React from 'react';

interface Props {
    checked: boolean;
}

const RadioBox: React.FC<Props> = (props: Props) => {

    return (
      <div className="z-radiobox">
          {
            props.checked && <div className="z-radiobox-selected"/>
          }
      </div>
    );
};

export default RadioBox;
